import { render, staticRenderFns } from "./CreateUnitModel.vue?vue&type=template&id=15268713&scoped=true&"
import script from "./CreateUnitModel.vue?vue&type=script&lang=js&"
export * from "./CreateUnitModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15268713",
  null
  
)

export default component.exports